import React, { useEffect } from 'react';
import { htmlSeguro, puntosTotales } from '../../../lib/formularios';
import { ENCABEZADO, useEditor } from './contexto';
import { TextoCreciente } from './controles';
import TextoEnriquecido from './TextoEnriquecido';

/** Tarjeta de arriba: título y descripción del formulario (la franja de color del tema la pone forms.css). */
export default function TarjetaEncabezado({ registrar }) {
  const ed = useEditor();
  const { formulario, puedeEditar, activo, setActivo, setCampo, esCuestionario } = ed;
  const activa = puedeEditar && activo === ENCABEZADO;
  const tituloRef = React.useRef(null);

  // Un formulario recién creado arranca con el cursor en el título
  useEffect(() => {
    if (!activa || ed.nuevoFoco !== ENCABEZADO) return;
    tituloRef.current?.focus();
    tituloRef.current?.select();
    ed.limpiarNuevoFoco();
  }, [activa, ed]);

  const puntos = esCuestionario ? puntosTotales(formulario.items) : null;

  return (
    <div
      ref={(el) => registrar(ENCABEZADO, el)}
      className={`fm-tarjeta fm-tarjeta-encabezado fe-tarjeta ${activa ? 'is-activa' : ''}`}
      onMouseDown={() => puedeEditar && !activa && setActivo(ENCABEZADO)}
      onFocusCapture={() => puedeEditar && !activa && setActivo(ENCABEZADO)}
    >
      {activa ? (
        <>
          <TextoCreciente
            inputRefExterno={tituloRef}
            className="fe-input-titulo fe-input-titulo-form fm-titulo-form"
            value={formulario.titulo}
            placeholder="Formulario sin título"
            aria-label="Título del formulario"
            onChange={(e) => setCampo('titulo', e.target.value, { clave: 'form:titulo' })}
          />
          <TextoEnriquecido
            className="fe-descripcion-form"
            valor={formulario.descripcion}
            placeholder="Descripción del formulario"
            etiqueta="Descripción del formulario"
            onCambio={(html) => setCampo('descripcion', html, { clave: 'form:descripcion' })}
          />
        </>
      ) : (
        <div
          role={puedeEditar ? 'button' : undefined}
          tabIndex={puedeEditar ? 0 : undefined}
          onKeyDown={(e) => {
            if (puedeEditar && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              setActivo(ENCABEZADO);
            }
          }}
        >
          <div className="fm-titulo-form">{formulario.titulo || <span className="fe-sin-titulo">Formulario sin título</span>}</div>
          {formulario.descripcion && (
            <div className="fm-descripcion fe-vista-descripcion" dangerouslySetInnerHTML={{ __html: htmlSeguro(formulario.descripcion) }} />
          )}
        </div>
      )}
      {puntos !== null && (
        <div className="fe-puntos-totales">Puntos totales: <strong>{puntos}</strong></div>
      )}
    </div>
  );
}
